import React from "react";

import async from "../components/Utility/Async/Async";

import { Users, DollarSign, Meh, PenTool } from "react-feather";

import { Redirect } from "react-router-dom";

import { connect } from "react-redux";

import { Settings } from "@mui/icons-material";

import * as menuStates from "../redux/menuStates";
import Glossary from "../pages/Glossary/Glossary";
import CapitalGainsTaxes from "../pages/admin/Settings/CapitalGainsTaxes/CapitalGainsTaxes";

// Auth components
const SignIn = async(() => import("../pages/auth/SignIn"));
const BuyNow = async(() => import("../pages/auth/BuyNow/BuyNow"));
const ResetPassword = async(() => import("../pages/auth/ResetPassword"));
const Page404 = async(() => import("../pages/auth/Page404"));
const Page500 = async(() => import("../pages/auth/Page500"));
const PageUnpaid = async(() => import("../pages/auth/PageUnpaid"));
const SignUpCompleted = async(() =>
  import("../pages/auth/SignUp/SignUpComplete")
);

// Advisor Pages
const HomeDashboard = async(() =>
  import("../pages/HomeDashboard/HomeDashboard")
);

const ClientList = async(() =>
  import("../pages/advisor/ClientList/ClientList")
);

const ArchivedClients = async(() =>
  import("../pages/advisor/ClientList/ArchivedClientList")
);

const FamilyList = async(() =>
  import("../pages/advisor/ClientDetails/Profile/Family/FamilyList")
);
const OtherList = async(() =>
  import("../pages/advisor/ClientDetails/Profile/Other/OtherList")
);

// Plans
const PlanList = async(() =>
  import("../pages/advisor/ClientDetails/Plans/PlanList/PlanList")
);
const PlanDetails = async(() =>
  import("../pages/advisor/ClientDetails/Plans/PlanDetails/PlanDetails")
);

const PlanComparison = async(() =>
  import("../pages/advisor/ClientDetails/Plans/PlanComparison/PlanComparison")
);

const ScenarioList = async(() =>
  import(
    "../pages/advisor/ClientDetails/Plans/ScenarioPlanner/ScenarioList/ScenarioList"
  )
);

const ScenarioBuilder = async(() =>
  import(
    "../pages/advisor/ClientDetails/Plans/ScenarioPlanner/ScenarioBuilder/ScenarioBuilder"
  )
);

const PlanOptimized = async(() =>
  import(
    "../pages/advisor/ClientDetails/Plans/PlanDetailsOptimization/PlanDetails"
  )
);

// Advisor Settings
const AdvisorInflationValues = async(() =>
  import("../pages/advisor/Settings/InflationValues/InflationValues")
);

// Advisor Customization
const advisorReportCustomization = async(() =>
  import("../pages/advisor/Customization/AdvisorReportCustomization")
);

const AdvisorDefaultTaxRates = async(() =>
  import("../pages/advisor/Settings/DefaultTaxRates/DefaultTaxRates")
);

const AdvisorClientKeyDates = async(() =>
  import("../pages/advisor/Settings/ClientKeyDates/ClientKeyDates")
);

const AdvisorMarginalTaxBracket = async(() =>
  import("../pages/advisor/Settings/MarginalTaxBracket/MarginalTaxBracket")
);

const AdvisorTaxDeduction = async(() =>
  import("../pages/advisor/Settings/TaxDeduction/TaxDeduction")
);

const AdvisorRenewal = async(() =>
  import("../pages/advisor/Payments/Renewal/Renewal")
);

const AdvisorUpdateBilling = async(() =>
  import("../pages/advisor/Payments/UpdateBilling/UpdateBilling")
);

const AdvisorPaymentHistory = async(() =>
  import("../pages/advisor/Payments/PaymentHistory/PaymentHistory")
);

const AdvisorSubscription = async(() =>
  import("../pages/advisor/Payments/Subscription/Subscription")
);

// Administration Pages
const AdminUsers = async(() => import("../pages/admin/Users/Users"));
const Teams = async(() => import("../pages/admin/Teams/Teams"));
const PaymentHistory = async(() =>
  import("../pages/admin/Payments/PaymentHistory")
);
const UpdateBilling = async(() =>
  import("../pages/admin/Payments/UpdateBilling")
);
const Renewal = async(() => import("../pages/admin/Payments/Renewal"));
const Subscription = async(() =>
  import("../pages/admin/Payments/Subscription")
);

const AdminInflationValues = async(() =>
  import("../pages/admin/Settings/InflationValues/InflationValues")
);
const AdminDefaultTaxRates = async(() =>
  import("../pages/admin/Settings/DefaultTaxRates/DefaultTaxRates")
);
const AdminClientKeyDates = async(() =>
  import("../pages/admin/Settings/ClientKeyDates/ClientKeyDates")
);
const AdminMarginalTaxBracket = async(() =>
  import("../pages/admin/Settings/MarginalTaxBracket/MarginalTaxBracket")
);
const AdminTaxDeduction = async(() =>
  import("../pages/admin/Settings/TaxDeduction/TaxDeduction")
);
const AdminReportCustomization = async(() =>
  import("../pages/admin/Customization/ReportCustomization")
);

const AdminSummaryHeader = async(() =>
  import("../pages/admin/Customization/SummaryHeader")
);

const AdminCustomizeTemplates = async(() =>
  import("../pages/admin/Customization/CustomizeTemplates")
);

const AdminMilestoneIndicators = async(() =>
  import("../pages/admin/Customization/MilestoneIndicators")
);

const AdminIntegrations = async(() =>
  import("../pages/admin/Customization/Integrations")
);
const DefaultInflation = async(() =>
  import("../components/Modules/DefaultInflation/DefaultInflation")
);
const StateTaxesPage = async(() =>
  import("../pages/admin/Settings/StateTaxes/StateTaxesPage")
);
const TaxCredits = async(() =>
  import("../pages/admin/Settings/TaxCredits/TaxCredits")
);
const AdminIncome = async(() =>
  import("../pages/admin/Settings/SurvivorChart/Income")
);

// User Profile Pages
const AddressPage = async(() =>
  import("../pages/advisor/UserProfile/Address/Address")
);

const ContactPage = async(() =>
  import("../pages/advisor/UserProfile/Contact/Contact")
);

const PasswordPage = async(() =>
  import("../pages/advisor/UserProfile/Password/Password")
);

const SecurityQuestions = async(() =>
  import("../pages/advisor/UserProfile/SecurityQuestions/SecurityQuestions")
);

const UserId = async(() =>
  import("../pages/advisor/UserProfile/UserId/UserId")
);

const SignatureLine = async(() =>
  import("../pages/advisor/UserProfile/SignatureLine/SignatureLine")
);

const Avatar = async(() =>
  import("../pages/advisor/UserProfile/Avatar/Avatar")
);

const Appearance = async(() =>
  import("../pages/advisor/UserProfile/Appearance/Appearance")
);

const placeholder = () => {
  return <div>This is a placeholder.</div>;
};

const createRedirectRoute = (target) => {
  const createRedirectRouteBase = (props) => {
    const currentClient = props.currentClient.toJS();
    const clientId = currentClient.client.id;

    return <Redirect to={target.replace(":id", clientId)} />;
  };

  const mapStateToProps = (state) => {
    return {
      currentClient: state.currentClientReducer,
    };
  };

  return connect(mapStateToProps)(createRedirectRouteBase);
};

const authRoutes = {
  id: "Auth",
  path: "/auth",
  icon: <Users />,
  children: [
    {
      path: "/",
      name: "Sign In",
      component: SignIn,
    },
    {
      path: "/auth/sign-in",
      name: "Sign In",
      component: SignIn,
    },
    {
      path: "/auth/reset-password",
      name: "Reset Password",
      component: ResetPassword,
    },
    {
      path: "/auth/404",
      name: "404 Page",
      component: Page404,
    },
    {
      path: "/auth/500",
      name: "500 Page",
      component: Page500,
    },
    {
      path: "/auth/unpaid",
      name: "Unpaid Page",
      component: PageUnpaid,
    },
    {
      path: "/auth/sign-up-completed",
      name: "Signup Completed",
      component: SignUpCompleted,
    },
  ],
};

const buyFlowRoutes = {
  id: "buyflow",
  path: "/purchase",
  icon: <Users />,
  children: [
    {
      path: "/purchase/buy-now",
      name: "Buy Now",
      component: BuyNow,
    },
  ],
};

const clientsRoutes = {
  id: "Clients",
  path: "/advisor/clients",
  icon: <Users />,
  allowedStates: [menuStates.MENU_STATE_ADVISOR],
  component: ClientList,
  children: null,
};

const dashboardRoutes = {
  id: "Dashboard",
  path: "/advisor/dashboard",
  allowedStates: [menuStates.MENU_STATE_ADVISOR],
  component: HomeDashboard,
  children: null,
};

const archivedClientRoute = {
  id: "ArchivedClients",
  path: "/advisor/clients/archived-clients",
  allowedStates: [menuStates.MENU_STATE_ADVISOR],
  component: ArchivedClients,
  children: null,
};

const clientDetails = {
  id: "ClientDetails",
  path: "/advisor/clients/details",
  icon: <Users />,
  allowedStates: [menuStates.MENU_STATE_ADVISOR],
  component: placeholder,
  children: [
    {
      path: "/advisor/clients/details/:id/profile",
      name: "Profile",
      component: createRedirectRoute(
        "/advisor/clients/details/:id/profile/network/family"
      ),
      children: [
        {
          path: "/advisor/clients/details/:id/profile/network",
          name: "Network",
          component: placeholder,
          children: [
            {
              path: "/advisor/clients/details/:id/profile/network/family",
              name: "Family",
              component: FamilyList,
            },
            {
              path: "/advisor/clients/details/:id/profile/network/other",
              name: "Other",
              component: OtherList,
            },
          ],
        },
      ],
    },
    {
      path: "/advisor/clients/details/:id/plans",
      name: "Plans",
      component: PlanList,
      children: [
        {
          path: "/advisor/clients/details/:id/plans/details/:planId",
          name: "Plan Details",
          component: PlanDetails,
          hide: true,
        },
      ],
    },
    {
      path: "/advisor/clients/details/:id/scenarios",
      name: "Scenarios",
      component: ScenarioList,
      children: [
        {
          path: "/advisor/clients/details/:id/scenarios/:scenarioId",
          name: "Scenario Details",
          component: ScenarioBuilder,
          hide: true,
          minimizeHeader: true,
        },
        {
          path: "/advisor/clients/details/:id/scenarios/:scenarioId/:subItemId",
          name: "Scenario Details",
          component: ScenarioBuilder,
          hide: true,
          minimizeHeader: true,
        },
      ],
    },
  ],
};

const userProfileRoutes = {
  id: "UserProfile",
  name: "Profile",
  path: "/advisor",
  icon: <Users />,
  allowedStates: [menuStates.MENU_STATE_ADVISOR],
  component: placeholder,
  children: [
    {
      path: "/advisor/profile",
      name: "Information",
      headerName: "Profile",
      component: createRedirectRoute("/advisor/profile/information/contact"),
      children: [
        {
          path: "/advisor/profile/information",
          name: "Information",
          component: createRedirectRoute(
            "/advisor/profile/information/contact"
          ),
          children: [
            {
              path: "/advisor/profile/information/contact",
              name: "Contact",
              component: ContactPage,
            },
            {
              path: "/advisor/profile/information/address",
              name: "Address",
              component: AddressPage,
            },
            {
              path: "/advisor/profile/information/signature",
              name: "Signature Line",
              component: SignatureLine,
            },
            {
              path: "/advisor/profile/information/avatar",
              name: "Photo Upload",
              component: Avatar,
            },
          ],
        },
        {
          path: "/advisor/profile/preferences",
          name: "Preferences",
          component: createRedirectRoute(
            "/advisor/profile/preferences/appearance"
          ),
          children: [
            {
              path: "/advisor/profile/preferences/appearance",
              name: "Appearance",
              component: Appearance,
            },
          ],
        },
        {
          path: "/advisor/profile/security",
          name: "Security",
          headerName: "Profile",
          component: placeholder,
          children: [
            {
              path: "/advisor/profile/security/userid",
              name: "User ID",
              component: UserId,
            },
            {
              path: "/advisor/profile/security/password",
              name: "Password",
              component: PasswordPage,
            },
            {
              path: "/advisor/profile/security/security-questions",
              name: "Security Questions",
              component: SecurityQuestions,
            },
          ],
        },
      ],
    },
  ],
};

const adminUserRoute = {
  id: "Users",
  path: "/admin/users",
  allowedStates: [menuStates.MENU_STATE_ADMIN],
  icon: <Users />,
  component: AdminUsers,
};

const adminTeamsRoute = {
  id: "Teams",
  path: "/admin/teams",
  allowedStates: [menuStates.MENU_STATE_ADMIN],
  icon: <Meh />,
  component: Teams,
};

const adminPaymentsRoutes = {
  id: "Payments",
  path: "/admin/payments",
  containsHome: true,
  allowedStates: [menuStates.MENU_STATE_ADMIN],
  icon: <DollarSign />,
  children: [
    {
      path: "/admin/payments/paymentHistory",
      name: "Payment History",
      component: PaymentHistory,
    },
  ],
};

const GlossaryRoute = {
  id: "Glossary",
  path: "/glossary",
  name: "Glossary",
  icon: <Settings />,
  component: Glossary,
};

const PlanCompareRoute = {
  id: "PlanCompare",
  path: "/plan-compare",
  name: "Plan Compare",
  component: PlanComparison,
};

const advisorSettingsRoute = {
  id: "Advisor Settings",
  path: "/advisor/settings",
  name: "Plan Settings",
  icon: <Settings />,
  allowedStates: [menuStates.MENU_STATE_ADVISOR],
  component: createRedirectRoute(
    "/advisor/settings/plan-settings/default-settings"
  ),
  children: [
    {
      path: "/advisor/settings/plan-settings",
      name: "Plan Settings",
      headerName: "Plan Settings",
      component: createRedirectRoute(
        "/advisor/settings/plan-settings/default-settings"
      ),
      children: [
        {
          path: "/advisor/settings/plan-settings/default-settings",
          name: "Default Settings",
          component: createRedirectRoute(
            "/advisor/settings/plan-settings/default-settings/inflation-values"
          ),
          children: [
            {
              path:
                "/advisor/settings/plan-settings/default-settings/inflation-values",
              name: "Inflation Values",
              component: AdvisorInflationValues,
            },
            {
              path:
                "/advisor/settings/plan-settings/default-settings/client-key-dates",
              name: "Client Key Dates",
              component: AdvisorClientKeyDates,
            },
          ],
        },
        {
          path: "/advisor/settings/plan-settings/default-taxes",
          name: "Default Taxes",
          component: placeholder,
          children: [
            {
              path:
                "/advisor/settings/plan-settings/default-taxes/default-tax-rates",
              name: "Capital Gains Taxes",
              component: AdvisorDefaultTaxRates,
            },
            {
              path:
                "/advisor/settings/plan-settings/default-taxes/marginal-tax-bracket",
              name: "Federal Taxes",
              component: AdvisorMarginalTaxBracket,
            },
            {
              path:
                "/advisor/settings/plan-settings/default-taxes/tax-deduction",
              name: "Tax Deduction",
              component: AdvisorTaxDeduction,
            },
          ],
        },
      ],
    },
  ],
};

const adminSettingsRoutes = {
  id: "Admin Settings",
  path: "/admin/settings",
  icon: <Settings />,
  allowedStates: [menuStates.MENU_STATE_ADMIN],
  component: placeholder,
  children: [
    {
      path: "/admin/settings/plan-settings",
      name: "Plan Settings",
      headerName: "Plan Settings",
      component: createRedirectRoute(
        "/admin/settings/plan-settings/default-settings"
      ),
      children: [
        {
          path: "/admin/settings/plan-settings/default-settings",
          name: "Default Settings",
          component: createRedirectRoute(
            "/admin/settings/plan-settings/default-settings/inflation-values"
          ),
          children: [
            {
              path:
                "/admin/settings/plan-settings/default-settings/inflation-values",
              name: "Inflation Values",
              component: AdminInflationValues,
            },
            {
              path:
                "/admin/settings/plan-settings/default-settings/client-key-dates",
              name: "Client Key Dates",
              component: AdminClientKeyDates,
            },
          ],
        },
        {
          path: "/admin/settings/plan-settings/default-taxes",
          name: "Default Taxes",
          component: placeholder,
          children: [
            {
              path:
                "/admin/settings/plan-settings/default-taxes/default-tax-rates",
              name: "Capital Gains Tax",
              component: CapitalGainsTaxes,
            },
            {
              path:
                "/admin/settings/plan-settings/default-taxes/marginal-tax-bracket",
              name: "Federal Taxes",
              component: AdminMarginalTaxBracket,
            },
            {
              path: "/admin/settings/plan-settings/default-taxes/tax-deduction",
              name: "Tax Deduction",
              component: AdminTaxDeduction,
            },
            {
              path: "/admin/settings/plan-settings/default-taxes/state-taxes",
              name: "State Taxes",
              component: StateTaxesPage,
            },
            {
              path:
                "/admin/settings/plan-settings/default-taxes/default-inflation",
              name: "Tax Inflation",
              component: DefaultInflation,
            },
            {
              path:
                "/admin/settings/plan-settings/default-settings/tax-credits",
              name: "Tax Credits",
              component: TaxCredits,
            },
            {
              path:
                "/admin/settings/plan-settings/default-settings/social-security",
              name: "Social Security Survivor Chart",
              component: AdminIncome,
            },
          ],
        },
      ],
    },
  ],
};

const adminSubscription = {
  id: "Admin Billing",
  path: "/admin/billing",
  allowedStates: [menuStates.MENU_STATE_ADMIN],
  icon: <DollarSign />,
  component: placeholder,
  children: [
    {
      path: "/admin/billing/placeholder",
      name: "Admin Subscription",
      headerName: "Admin Subscription",
      component: placeholder,
      children: [
        {
          path: "/admin/billing/subscription",
          name: "Admin Subscription",
          component: createRedirectRoute(
            "/admin/billing/subscription/payment-history"
          ),
          children: [
            {
              path: "/admin/billing/subscription/subscription",
              name: "Subscription",
              hide: true,
              component: Subscription,
            },
            {
              path: "/admin/billing/subscription/payment-history",
              name: "Payment History",
              component: PaymentHistory,
            },
            {
              path: "/admin/billing/subscription/billing-information",
              name: "Billing Information",
              component: UpdateBilling,
            },
            {
              path: "/admin/billing/subscription/renew-subscription",
              name: "Renew Subscription",
              component: Renewal,
            },
          ],
        },
      ],
    },
  ],
};

const advisorSubscription = {
  id: "Advisor Billing",
  path: "/advisor/billing",
  allowedStates: [menuStates.MENU_STATE_ADVISOR],
  icon: <DollarSign />,
  component: placeholder(),
  children: [
    {
      path: "/advisor/billing/placeholder",
      name: "Advisor Subscription",
      headerName: "Advisor Subscription",
      component: createRedirectRoute(
        "/advisor/billing/subscription/billing-information"
      ),
      children: [
        {
          path: "/advisor/billing/subscription",
          name: "Advisor Subscription",
          component: createRedirectRoute(
            "/advisor/billing/subscription/billing-information"
          ),
          children: [
            {
              path: "/advisor/billing/subscription/subscription",
              name: "Subscription",
              hide: true,
              component: AdvisorSubscription,
            },
            {
              path: "/advisor/billing/subscription/billing-information",
              name: "Billing Information",
              component: AdvisorUpdateBilling,
            },
            {
              path: "/advisor/billing/subscription/renew-subscription",
              name: "Renew Subscription",
              component: AdvisorRenewal,
            },
            {
              path: "/advisor/billing/subscription/payment-history",
              name: "Payment History",
              component: AdvisorPaymentHistory,
            },
          ],
        },
      ],
    },
  ],
};

const adminCustomization = {
  id: "Admin Customization",
  path: "/admin/customization",
  allowedStates: [menuStates.MENU_STATE_ADMIN],
  icon: <DollarSign />,
  component: createRedirectRoute("/admin/customization/logo"),
  children: [
    {
      path: "/admin/customization/logo",
      name: "Admin Customization",
      headerName: "Admin Customization",
      component: createRedirectRoute("/admin/customization/reportlogo"),
      children: [
        {
          path: "/admin/customization/reportlogo",
          name: "Reports",
          component: createRedirectRoute(
            "/admin/customization/adminreportlogo"
          ),
          children: [
            {
              path: "/admin/customization/adminreportlogo",
              name: "Cover Page",
              component: AdminReportCustomization,
            },
            {
              path: "/admin/customization/summary-header",
              name: "Summary Header",
              component: AdminSummaryHeader,
            },
            {
              path: "/admin/customization/admincustomizetemplates",
              name: "Customize Templates",
              component: AdminCustomizeTemplates,
            },
            {
              path: "/admin/customization/milestones",
              name: "Milestone Indicators",
              component: AdminMilestoneIndicators,
            },
          ],
        },
        {
          path: "/admin/customization/adminintegrations",
          name: "Integrations",
          component: createRedirectRoute("/admin/customization/integrations"),
          children: [
            {
              path: "/admin/customization/integrations",
              name: "Integrations",
              component: AdminIntegrations,
            },
          ],
        },
      ],
    },
  ],
};

const advisorCustomization = {
  id: "Advisor Customization",
  path: "/advisor/customization",
  name: "Advisor Customization",
  icon: <Settings />,
  allowedStates: [menuStates.MENU_STATE_ADVISOR],
  component: createRedirectRoute("/advisor/customization/logo"),
  children: [
    {
      path: "/advisor/customization/",
      name: "Advisor Customization",
      headerName: "Advisor Customization",
      component: createRedirectRoute("/advisor/customization/logo"),
      children: [
        {
          path: "/advisor/customization/logo",
          name: "Customization",
          component: createRedirectRoute(
            "/advisor/customization/logo/logo_report"
          ),
          children: [
            {
              path: "/advisor/customization/logo/logo_report",
              name: "Report Cover Page",
              component: advisorReportCustomization,
            },
          ],
        },
      ],
    },
  ],
};

export const dashboard = [
  clientsRoutes,
  dashboardRoutes,
  archivedClientRoute,
  adminPaymentsRoutes,
  adminUserRoute,
  adminTeamsRoute,
];

export const auth = [authRoutes];

export const nav = [clientDetails];

export const userProfile = [userProfileRoutes];

export const settings = [advisorSettingsRoute];

export const adminSettings = [adminSettingsRoutes];

export const glossary = [GlossaryRoute];

export const adminPayments = [adminSubscription];

export const advisorPayments = [advisorSubscription];

export const adminCustomizations = [adminCustomization];

export const advisorCustomizations = [advisorCustomization];

export const buyFlow = [buyFlowRoutes];

export const planCompare = [PlanCompareRoute];

export default [
  clientsRoutes,
  archivedClientRoute,
  adminPaymentsRoutes,
  adminUserRoute,
  adminTeamsRoute,
  buyFlowRoutes,
  planCompare,
];
